import { isDevHubContext } from './hubEnv.js';

export const VISIBILITY_SCOPES = Object.freeze({
  PUBLIC: 'public',
  PRIVATE: 'private',
  STAGING: 'staging',
  UNLISTED: 'unlisted',
});

const VALID_SCOPES = new Set(Object.values(VISIBILITY_SCOPES));

export const VISIBILITY_SCOPE_OPTIONS = [
  { value: VISIBILITY_SCOPES.PUBLIC, label: '公開', description: '本番・ステージングの両方で表示・利用できます' },
  { value: VISIBILITY_SCOPES.STAGING, label: 'ステージングのみ', description: 'ステージング環境でのみ表示・利用できます（本番では非表示）' },
  { value: VISIBILITY_SCOPES.UNLISTED, label: '限定公開（先行利用）', description: 'カタログには表示されませんが、付与されたクリニックは本番を含む全環境で利用できます' },
  { value: VISIBILITY_SCOPES.PRIVATE, label: '非公開', description: 'すべての環境で非表示・付与不可です（廃止・停止）' },
];

export function normalizeVisibilityScope(product) {
  const raw = product?.visibilityScope;
  if (typeof raw === 'string' && VALID_SCOPES.has(raw)) {
    return raw;
  }
  if (product?.isActive === false) {
    return VISIBILITY_SCOPES.PRIVATE;
  }
  return VISIBILITY_SCOPES.PUBLIC;
}

export function getVisibilityScopeLabel(scope) {
  return VISIBILITY_SCOPE_OPTIONS.find((option) => option.value === scope)?.label || '公開';
}

export function isActiveForStorage(visibilityScope) {
  return normalizeVisibilityScope({ visibilityScope }) !== VISIBILITY_SCOPES.PRIVATE;
}

/** Admin UI 等: 現在のホストが dev/staging かどうかで表示可否を判定（カタログ表示相当） */
export function isProductVisibleInClientContext(product) {
  const scope = normalizeVisibilityScope(product);
  if (scope === VISIBILITY_SCOPES.PRIVATE) return false;
  if (scope === VISIBILITY_SCOPES.UNLISTED) return false;
  if (scope === VISIBILITY_SCOPES.STAGING) return isDevHubContext();
  return true;
}
